export default {"src":"/_next/static/media/wicket-art.364e7efc.svg","height":70,"width":86,"blurWidth":0,"blurHeight":0};